module.exports = __webpack_public_path__ + "static/img/join_2.2267564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/join_2.jpg
// module id = c92y
// module chunks = 0